import React, { useState } from "react";
import { PermissionWrapper, DeleteButton } from "components";
import { formatUah } from "utils";

// Компонент для відображення таблиці сторінки "Виключення"
const ExclusionsTable = React.memo(({ exclusions, onDelete, onUpdatePrice }) => {
  // Локальні стани для керування редагуванням
  const [editingArticle, setEditingArticle] = useState(null);
  const [editingPrice, setEditingPrice] = useState("");

  // Обробляє подвійне натискання на ціну
  const handlePriceDoubleClick = (article, currentPrice) => {
    setEditingArticle(article);
    setEditingPrice(currentPrice);
  };

  // Надсилає запит на оновлення даних на сервер
  const handlePriceUpdate = (article) => {
    onUpdatePrice(article, editingPrice);

    // Прибираємо режим редагування
    setEditingArticle(null);
    setEditingPrice("");
  };

  return (
    <table>
      <thead>
        <tr>
          <th>Артикул</th>
          <th>Ціна з виключень</th>
          <PermissionWrapper requiredPermission="exclusions:delete">
            <th>Дії</th>
          </PermissionWrapper>
        </tr>
      </thead>
      <tbody>
        {exclusions.length === 0 ? (
          <tr>
            <td colSpan={3} className="empty-row">
              Немає даних товарів виключень
            </td>
          </tr>
        ) : (
          exclusions.map((item) => (
            <tr key={item.article}>
              <td>{item.article}</td>
              <PermissionWrapper
                requiredPermission="exclusions:edit"
                fallback={<td>{formatUah(item.new_price)}</td>}
              >
                <td
                  onDoubleClick={() =>
                    handlePriceDoubleClick(item.article, item.new_price)
                  }
                  className="clickable"
                >
                  {editingArticle === item.article ? (
                    <input
                      type="number"
                      value={editingPrice}
                      onChange={(e) => setEditingPrice(e.target.value)}
                      onBlur={() => handlePriceUpdate(item.article)}
                      onKeyDown={(e) =>
                        e.key === "Enter" && handlePriceUpdate(item.article)
                      }
                      autoFocus
                    />
                  ) : (
                    formatUah(item.new_price)
                  )}
                </td>
              </PermissionWrapper>
              <PermissionWrapper requiredPermission="exclusions:delete">
                <td>
                  <DeleteButton onDelete={() => onDelete(item.article)} />
                </td>
              </PermissionWrapper>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
});

export default ExclusionsTable;
